import { call, put, select, all } from "redux-saga/effects";
import {
  normalizerOrion,
  normalizerPorductCharacteristicsOrion,
} from "@/utils/normalizers/orion-normalizers";
import { ARRAY_SUBSECCION } from "@/constants/constants";
// import { handleSagaError } from '@/sagas/index';
import { actions as orionActions } from "@/reducers/orion";
import { checkMocks } from "@/utils/commonUtils";
import { normalizeGetMyProducts } from "@/sagas/normalizers/productNormalizer";
// import { getMyProducts } from "@gcloud-npm/adabyron.client.productos.mis-productos";
import { getMyProducts } from "@/adabyron/telcol/products/mis-productos";
import { getByName } from "@gcloud-npm/adabyron.custo.get-by-name";
import { ALIAS_HBO_MAX_ACTIVATION } from "@/constants/orion";

const contextStore = (state) => state.main.context;
const orionStore = (state) => state.orion;
const productStore = (state) => state.product;
const userPqStore = (state) => state.main.userPq;
const userRecomStore = (state) => state.main.userRecom;
const LIST = "list"

export function* getOrionInfoData({ handlingCode = 0, alias, path, conditionList, ignoreProductsWithoutRules}) {
  try {
    const MOCK_INFO = "getOrionInfo";
    let orionInfoRequest = null;
    const { orionInfo } = yield select(orionStore);
    const context = yield select(contextStore);
    const userPq = yield select(userPqStore);
    const userRecom = yield select(userRecomStore);
    if (!orionInfo || !orionInfo[alias]) {
      let response = checkMocks(MOCK_INFO);
      if (response === null) {
        const getOrionInfoModule = yield call(() =>
          import("@gcloud-npm/adabyron.orion.get-by-alias")
        );
        const { getByAlias } = getOrionInfoModule;
          response = yield call(getByAlias, {
            alias,
            context,
            path,
            conditionList,
            ignoreProductsWithoutRules
          });
      }
      let myProductsList = null;
      // if (
      //   alias === 'AP_PAGE_GESTIONES_DISTRIBUTIVA_DISTRI'
      //   || alias === 'AP_PAGE_GESTIONES_CONSUMO_AREA_PRIVADA'
      // ) {
      if (true) {
        const { hiredProductsList } = yield select(productStore);
        if (Array.isArray(hiredProductsList) && hiredProductsList.length > 0) {
          myProductsList = hiredProductsList;
        } else {
          const data = { catalogSubSections: ARRAY_SUBSECCION };
          const response = yield call(getMyProducts, {
            data,
            context,
          });
          myProductsList = normalizeGetMyProducts(response.datos);
        }
      }
      if (response && !response.data) {
        const orionListOrOrionProduct = (response && response.responseMap && Object.keys(response.responseMap)
                                        && Object.keys(response.responseMap).length>0
                                        && response.responseMap[Object.keys(response.responseMap)[0]]
                                        && response.responseMap[Object.keys(response.responseMap)[0]].data) || false;
        if (orionListOrOrionProduct) {
          orionInfoRequest = normalizerOrion(
            response.responseMap[Object.keys(response.responseMap)[0]].data,
            myProductsList
          );
        }
      } else {
        orionInfoRequest = normalizerOrion(response.data, myProductsList);
      }
      if (orionInfoRequest.normalizeInfoCustoMejora) {
        const title = orionInfoRequest.normalizeInfoCustoMejora?.activityTitle;
        let activityTitleResponse = null;     
        orionInfoRequest.normalizeInfoCustoMejora.activityTitle =
          activityTitleResponse;
        const activityList =
          orionInfoRequest.normalizeInfoCustoMejora?.activitiesList;
        //----------------------------------------------------
        let activiyListResponseMejora = [];
        if(title){
          activiyListResponseMejora.push(
          getByName({
            name: title,
            build:false,
            context: context,
            userPq: userPq,
            userRecom: userRecom,
            custoVersion: 3,
          }));
        }
        if(activityList && Array.isArray(activityList) && activityList.length>0){
          activityList.forEach((itemM, index) => {
            activiyListResponseMejora.push(
              getByName({
                name: itemM.name,
                context: context,
                build:false,
                userPq: userPq,
                userRecom: userRecom,
                custoVersion: 3,
              })
            );
          });
        }
        let activiyListResponseM = null;
        try {
          activiyListResponseM= yield all (activiyListResponseMejora);
          orionInfoRequest.normalizeInfoCustoMejora.activityTitle = activiyListResponseM[0];
          activiyListResponseM.splice(0,1);
          orionInfoRequest.normalizeInfoCustoMejora.activitiesList = activiyListResponseM;
        } catch (error) {
          console.log(error)
        }
      }


      if (orionInfoRequest.normalizeInfoCustoOtros) {
        const title = orionInfoRequest.normalizeInfoCustoOtros.activityTitle;
        let activityTitleResponse = null;
        orionInfoRequest.normalizeInfoCustoOtros.activityTitle =
          activityTitleResponse;
        const activityList =
          orionInfoRequest.normalizeInfoCustoOtros.activitiesList;
        //----------------------------------------------------
        let activiyListResponseOtros = [];
        activiyListResponseOtros.push(
        getByName({
          name: title,
          build:false,
          context: context,
          userPq: userPq,
          userRecom: userRecom,
          custoVersion: 3,
        }));
        activityList.forEach((itemO, index) => {
          activiyListResponseOtros.push(
            getByName({
              build:false,
              name: itemO.name,
              context: context,
              userPq: userPq,
              userRecom: userRecom,
              custoVersion: 3,
            })
          );
        });
        let activiyListResponseO = null;
        try {
          activiyListResponseO= yield all (activiyListResponseOtros);
          orionInfoRequest.normalizeInfoCustoOtros.activityTitle = activiyListResponseO[0];
          activiyListResponseO.splice(0,1);
          orionInfoRequest.normalizeInfoCustoOtros.activitiesList = activiyListResponseO;
        } catch (error) {
          console.log(error);
        }

      }
    } else {
      orionInfoRequest = orionInfo[alias];
    }
    yield put(
      orionActions.successOrionInfoData({
        orionInfoRequest,
        alias,
        orionInfoStatus: false,
      })
    );
  } catch (error) {
    console.log(error);
    // yield put(orionActions.successOrionInfoData({ orionInfoStatus: error }));
  }
}


export function* getOrionProductCharacteristics({ handlingCode = 0, alias, path, conditionList, ignoreProductsWithoutRules,productOffering }) {
  try {
    const MOCK_INFO = "getOrionInfo";
    const context = yield select(contextStore);
    let response = checkMocks(MOCK_INFO);
    if (response === null) {
      // Si tenemos que beber del LIST en vez del metodo de product de orion
      if(alias===LIST){
        const getOrionInfoModule = yield call(() =>
          import("@gcloud-npm/adabyron.orion.get-by-alias")
        );
        const { getByAlias } = getOrionInfoModule;
          response = yield call(getByAlias, {
            alias,
            context,
            path,
            conditionList,
            ignoreProductsWithoutRules
          });
          alias= productOffering;
      }else{
        const getOrionInfoModule = yield call(() =>
          import("@gcloud-npm/adabyron.orion.get-by-product-offering")
        );
        const { getByProductOffering } = getOrionInfoModule;
        response = yield call(getByProductOffering, {
          alias,
          context,
          path,
          conditionList,
          ignoreProductsWithoutRules
        });
      }
    }
    let orionProducstCharacteristicsRequest = null;
    if (response && !response.data) {
      const orionListOrOrionProduct = (response && response.responseMap && Object.keys(response.responseMap)
                                        && Object.keys(response.responseMap).length>0
                                        && response.responseMap[Object.keys(response.responseMap)[0]]
                                        && response.responseMap[Object.keys(response.responseMap)[0]].data) || false;
      if (orionListOrOrionProduct) {
        orionProducstCharacteristicsRequest = normalizerPorductCharacteristicsOrion(
          response.responseMap[Object.keys(response.responseMap)[0]].data,
          alias
        );
      }
    } else {
      orionProducstCharacteristicsRequest =
      normalizerPorductCharacteristicsOrion(response.data, alias);
    }

    yield put(
      orionActions.successOrionProductData({
        orionProducstCharacteristicsRequest,
        orionProducstCharacteristicsStatus: false,
      })
    );
    return {
      status: "ok",
    };
  } catch (error) {
    yield put(
      orionActions.successOrionProductData({
        orionProducstCharacteristicsRequest: null,
        orionProducstCharacteristicsStatus: error,
      })
    );
  }
}
